/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React from 'react';

import Input from 'components/forms/Input';
import PropTypes from 'prop-types';

import { isValidEmail } from '../../../validators/EmailInputValidators/EmailInputValidators';

const EmailInput = ({
  errors,
  register,
  dirtyFields,
  placeholder,
  label,
  defaultValue,
  readOnly,
  hideIcon,
  name,
  onChange,
  value,
  isRequired,
  ...rest
}) => (
  <Input
    autoComplete="email"
    isDirty={dirtyFields[name]}
    suffixIcon={!hideIcon ? { iconName: 'Email' } : null}
    label={`${label}${isRequired && !label?.endsWith('*') ? '*' : ''}`}
    name={name}
    placeholder={placeholder}
    defaultValue={defaultValue}
    error={errors[name]}
    readOnly={readOnly}
    onChange={onChange}
    value={value}
    inputRef={register(
      isRequired
        ? {
            required: 'This field is required',
            validate: (value) =>
              isValidEmail(value) === true || 'Please enter a valid email'
          }
        : {
            validate: (value) =>
              !value ||
              isValidEmail(value) === true ||
              'Please enter a valid email'
          }
    )}
    type="email"
    {...rest}
  />
);

EmailInput.propTypes = {
  errors: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  dirtyFields: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  readOnly: PropTypes.bool,
  hideIcon: PropTypes.bool,
  name: PropTypes.string,
  isRequired: PropTypes.bool
};

EmailInput.defaultProps = {
  placeholder: null,
  label: 'Email',
  defaultValue: null,
  readOnly: false,
  name: 'email',
  hideIcon: false,
  isRequired: true
};

export default EmailInput;
